import { KeyboardEvent, useState } from "react";
import LoginApi from "../../api/LoginApi";
import Api from "../../api/Api";
import SessionService from "../../services/session/SessionService";
import { ErrorMessage, FormItemInput, FormItemLabel, FormItemWrapper, FormSubmit, LoginDialogWrapper, LoginForm, LoginFormDescription, LoginFormTitle, LoginFormTitleEn, LoginFormWrapper, LoginPicture, LoginWrapper } from "./Login.styled";

interface LoginProps {
}

const Login: React.FC<LoginProps> = (props)=> {
    // login memorize values
    let loginMemorizeJson = localStorage.getItem("loginMemorize");
    let loginMemorize = {tenantName: '', userName: ''};
    if (loginMemorizeJson) {
        loginMemorize = JSON.parse(loginMemorizeJson);
    }

    // state
    let [tenantName, setTenantName] = useState(loginMemorize.tenantName);
    let [userName, setUserName] = useState(loginMemorize.userName);
    let [password, setPassword] = useState('');
    let [error, setError] = useState('');

    // events
    let onTenantNameChange = (value: string)=> {
        setTenantName(value);
    };

    let onUserNameChange = (value: string)=> {
        setUserName(value);
    };

    let onPasswordChange = (value: string)=> {
        setPassword(value);
    }

    let onPasswordKeyDown = (e: KeyboardEvent)=> {
        if (e.key.toLowerCase() == 'Enter'.toLowerCase()) {
            login();
        }
    }

    let login = async ()=> {
        let loginApi = new LoginApi();
        let signInData: any = {tenantNo: tenantName, userName: userName, password: password};
        localStorage.setItem("loginMemorize", JSON.stringify({tenantName, userName}));

        try {
            let loginResponse = await loginApi.signIn(signInData);
            if (loginResponse.data.code != Api.CODE_OK) {
                setError("用户名/密码不正确");
            } else {
                let sessionService = SessionService.getInstance();
                sessionService.setAuthorization(loginResponse.data.data.token);
                sessionService.fireSessionChangeListeners();
            }
        } catch (e) {
            setError("用户名/密码不正确");
        }
    };

    function setScale(wrapperDom: HTMLElement) {
        if (wrapperDom == null) {
            return;
        }
        let screenWidth = window.screen.width;
        let screenHeight = window.screen.height;

        let widthRatio = screenWidth / 1920;
        let heightRatio = screenHeight / 1080;
        let ratio = widthRatio > heightRatio ? widthRatio : heightRatio;
        let rootFontSize = 12 * ratio;
        document.documentElement.style.fontSize = `${rootFontSize}px`;
        document.body.style.fontSize = `${rootFontSize}px`;
        // wrapperDom.style.transform = `scale(${ratio}) translate(-50%,-50%)`;
    }

    // render
    return (
        <LoginWrapper ref={(dom)=> setScale(dom)}>
            <LoginDialogWrapper>
                <LoginFormWrapper>
                    <LoginForm>
                        <LoginFormTitle>智能卷扬机互联系统</LoginFormTitle>
                        <LoginFormTitleEn>Winch Link System</LoginFormTitleEn>
                        <LoginFormDescription>全面、智能且高效的设备监测与管理的平台，在这里您可以轻松追踪您设备的实时状态，获取最新的数据报告，以及进行各种智能分析。</LoginFormDescription>
                        
                        <FormItemWrapper>
                            <FormItemLabel>用户名称/编号</FormItemLabel>
                            <FormItemInput placeholder="请输入租户名称/编号" value={tenantName} onChange={(e)=> onTenantNameChange(e.target.value)}></FormItemInput>
                        </FormItemWrapper>
                        <FormItemWrapper>
                            <FormItemLabel>登录名/手机号/邮箱</FormItemLabel>
                            <FormItemInput placeholder="请输入用户名/手机号/邮箱" value={userName} onChange={(e)=> onUserNameChange(e.target.value)}></FormItemInput>
                        </FormItemWrapper>
                        <FormItemWrapper>
                            <FormItemLabel>密码</FormItemLabel>
                            <FormItemInput placeholder="请输入登录密码" type='password' style={{letterSpacing: '3px'}} value={password} onChange={(e)=> onPasswordChange(e.target.value)} onKeyDown={(e)=> onPasswordKeyDown(e)}></FormItemInput>
                        </FormItemWrapper>

                        <ErrorMessage>{error}</ErrorMessage>
                        
                        <FormSubmit onClick={login}>
                            登录
                        </FormSubmit>
                    </LoginForm>
                </LoginFormWrapper>
            </LoginDialogWrapper>
        </LoginWrapper>
    );
}

export default Login;

